import { render, staticRenderFns } from "./Unsupported.vue?vue&type=template&id=c9b70940&scoped=true"
import script from "./Unsupported.vue?vue&type=script&lang=js"
export * from "./Unsupported.vue?vue&type=script&lang=js"
import style0 from "./Unsupported.vue?vue&type=style&index=0&id=c9b70940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b70940",
  null
  
)

export default component.exports